import n from 'vscode/external/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".terminal-inline-chat{bottom:0;height:auto!important;left:0;position:absolute;z-index:100}.terminal-inline-chat .inline-chat{margin-top:0!important}.terminal-inline-chat.hide{visibility:hidden}.terminal-inline-chat .chatMessageContent .value{padding-top:10px}.terminal-inline-chat .inline-chat-input .monaco-editor-background{background-color:var(--vscode-inlineChatInput-background)!important}";
n(css,{});

export { css, css as default };
